"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionButtonsLoading = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsWeb = require("@olxbr/ds-web");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ActionButtonsLoading = exports.ActionButtonsLoading = function ActionButtonsLoading() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.FakeButton, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
        width: "100%",
        height: "100%"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.FakeButton, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
        width: "100%",
        height: "100%"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.FakeButton, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
        width: "100%",
        height: "100%"
      })
    })]
  });
};